<template>
    <div class="alert animated fast fadeInDown" :class="type" ref="alert">
        <div class="alert-title">{{title}}</div>
        <div class="alert-content">
            <slot></slot>
        </div>

        <div class="close fa fa-times" @click="close" />
    </div>
</template>

<script>
    export default {
        name: 'Alert',

        props: ['type','title', 'timeOut'],

        mounted(){
            setTimeout(this.close, this.timeOut)
        },

        methods: {
            close() {
                let alertClassList = this.$refs.alert.classList

                alertClassList.remove('fadeInDown')
                alertClassList.add('fadeOutUp')
            },
        }
    }
</script>